import React from 'react';
import Popover from '@material-ui/core/Popover';
import PropTypes from 'prop-types';

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  popoverStyle: {
    padding: '10px'
  }
}));



export default function SuperScript({num, text, url}) {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  
  const linkStyle = {
    color: '#1966c7',
    textDecoration: 'none'
  };

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };
  
  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <a 
        style={linkStyle}
        key={num}
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        aria-owns={open ? 'mouse-over-popover' : undefined}
        aria-haspopup="true"
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
      >
        <sup>{num}</sup>
      </a>

      <Popover
        id="mouse-over-popover"
        style={{pointerEvents: 'none'}}
        classes={{paper: classes.popoverStyle}}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        {text}
      </Popover>
    </>);
}

SuperScript.propTypes = {
  num: PropTypes.number.isRequired,
  text: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired
};